import styled from "styled-components";
import { token, radius, space, font } from "../theme";

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  max-width: 320px;
`;

/**
 * The viewfinder. Flat navy surface with a 1px alpha border, no shadow at rest.
 */
export const Container = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border: 1px solid ${token.borderDefault};
  border-radius: ${radius.md};
  background-color: ${token.bgSurface};
`;

export const Canvas = styled.canvas`
  display: block;
  width: 100%;
  height: auto;
`;

export const Video = styled.video`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;

  &::-webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }
`;

/** Covers the frame whenever there is no live feed to show. */
export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: ${space.md};
  padding: ${space.lg};
  background-color: ${token.bgSurface};
  text-align: center;
`;

export const OverlayTitle = styled.p`
  margin: 0;
  color: ${token.textPrimary};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
`;

export const OverlayText = styled.p`
  margin: 0;
  color: ${token.textSecondary};
  font-size: 0.875rem;
`;

export const OverlayAction = styled.button`
  appearance: none;
  padding: ${space.sm} ${space.md};
  border: 1px solid ${token.accent};
  border-radius: ${radius.sm};
  background-color: ${token.accent};
  color: ${token.textOnAccent};
  font-family: ${font.sans};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
`;
